import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import styles from './PaymentCancel.module.css';

const PaymentCancel = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className={styles.pageWrapper}>
      <div className={styles.card}>

        <div className={styles.icon}>&#x2715;</div>
        <h2 className={styles.title}>{t('Payment Cancelled')}</h2>
        <p className={styles.subtitle}>
          {t("You cancelled the payment. No charge was made. You can try again whenever you're ready.")}
        </p>

        <div className={styles.buttonRow}>
          <button
            className={styles.buttonPrimary}
            onClick={() => navigate('/payment')}
          >
            {t('Try Again')}
          </button>
          <button
            className={styles.buttonSecondary}
            onClick={() => navigate('/dashboard')}
          >
            {t('Go to Dashboard')}
          </button>
        </div>

      </div>
    </div>
  );
};

export default PaymentCancel;
